<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title>{{ name }}</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Name"
          v-model="name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-textarea
          label="Description"
          v-model="description"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Subject"
          v-model="subject"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="end"
      ><v-col cols="2" class="py-0"
        ><v-switch dense hide-details v-model="raw" label="Raw" /></v-col
    ></v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-if="raw"
          label="Email Body"
          v-model="template"
          :outlined="outlinedInputs"
          rows="10"
        ></v-textarea>
        <vue-editor v-model="template" v-else></vue-editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch label="Private" v-model="isPrivate" />
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ value }}</code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import { VueEditor } from "vue2-editor";
export default {
  name: "email-type-dialog",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { BasicDialog, VueEditor },

  data() {
    return {
      debug: false,
      raw: false,
      name: this.value ? this.value.name : "New Email Type",
      isPrivate: this.value ? this.value.isPrivate.toString() == "true" : true,
      description: this.value
        ? this.value.description
        : "Email Type Description",
      subject: this.value
        ? this.value.subject
        : "New Email Type Default Subject",
      template: this.value
        ? this.value.template
        : "New Email Type Default Body Content",
    };
  },

  computed: {
    isValid() {
      return this.name != "" && this.subject != "" && this.template != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal ? newVal.name : "New Email Type";
      this.description = newVal ? newVal.description : "";
      this.subject = newVal ? newVal.subject : "";
      this.template = newVal ? newVal.template : "";
      this.isPrivate = newVal && newVal.isPrivate.toString() == "true";
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        description: this.description,
        subject: this.subject,
        template: this.template,
        isPrivate: this.isPrivate,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/contents/EmailTypeDialog.vue